import React from 'react';

type WizardContainerType = {
  children: React.ReactNode;
  selectedStepId: string;
  className?: string;
};
const WizardContainer = ({ children, selectedStepId, className }: WizardContainerType) => {
  const child = React.Children.toArray(children).find((value: any) => value?.props?.tabId === selectedStepId);
  if (className) {
    return <div className={className}>{child}</div>;
  }
  return child;
};

export default WizardContainer;
